// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Json = require("@glennsl/bs-json/lib/js/src/Json.bs.js");
var Seed = require("./seed");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Fetch = require("bs-fetch/lib/js/src/Fetch.js");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Printf = require("bs-platform/lib/js/printf.js");
var FoodSeed = require("./foodSeed");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.bs.js");
var Json_encode = require("@glennsl/bs-json/lib/js/src/Json_encode.bs.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Js_primitive = require("bs-platform/lib/js/js_primitive.js");
var SupportFuncs = require("./supportFuncs");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

var dataUrl = "https://shopify.ilpt.de/api/apps/me?shop=ilptbook.myshopify.com";

function getBearer() {
  var match = localStorage.getItem("access_token");
  if (match !== null) {
    return match;
  } else {
    SupportFuncs.handleLogout(/* () */0);
    console.log("bearer missing. logging out.");
    return "fail, bearer missing";
  }
}

function jsonParse(vals) {
  try {
    return JSON.parse(vals);
  }
  catch (exn){
    return Pervasives.failwith("Error parsing JSON string");
  }
}

var networkSyncStatusSeed = /* array */[
  /* array */[
    "new",
    "0.0",
    "start_date_timestamp"
  ],
  /* array */[
    "new",
    "0.0",
    "wizard_result"
  ],
  /* array */[
    "new",
    "0.0",
    "levels"
  ],
  /* array */[
    "new",
    "0.0",
    "reps"
  ],
  /* array */[
    "new",
    "0.0",
    "points"
  ],
  /* array */[
    "new",
    "0.0",
    "completed"
  ],
  /* array */[
    "new",
    "0.0",
    "food_plan"
  ],
  /* array */[
    "new",
    "0.0",
    "bonus_done"
  ],
  /* array */[
    "new",
    "0.0",
    "knowledge_read"
  ]
];

function checkSync(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array(Json_decode.string, param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("sync parsing issue failure ", x[1]);
      return /* None */0;
    } else {
      console.log("sync parsing issue", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readSyncSettingsFromLs() {
  var exit = 0;
  var val;
  try {
    val = Js_primitive.null_to_opt(localStorage.getItem("network_sync_status"));
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("localStorage issue", x);
    return /* None */0;
  }
  if (exit === 1) {
    if (val) {
      var exit$1 = 0;
      var val$1;
      try {
        val$1 = /* Some */[jsonParse(val[0])];
        exit$1 = 2;
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === Caml_builtin_exceptions.failure) {
          console.log("sync checking exception: ", exn[1]);
          return /* None */0;
        } else {
          throw exn;
        }
      }
      if (exit$1 === 2) {
        if (val$1) {
          return checkSync(val$1[0]);
        } else {
          return /* None */0;
        }
      }
      
    } else {
      return /* None */0;
    }
  }
  
}

function pullSyncConfig() {
  var match = readSyncSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return networkSyncStatusSeed;
  }
}

function checkSyncConfigMissing() {
  var match = readSyncSettingsFromLs(/* () */0);
  if (match) {
    return /* None */0;
  } else {
    return /* Some */[networkSyncStatusSeed];
  }
}

function writeSyncStatusToLs(payload) {
  var syncRes = Json.stringify(payload);
  console.log("writeSyncStatusToLs");
  localStorage.setItem("network_sync_status", syncRes);
  return /* () */0;
}

function initializeSyncStatus2() {
  var res = checkSyncConfigMissing(/* () */0);
  if (res) {
    var syncRes = Json.stringify(res[0]);
    console.log("initializeSyncStatus2", syncRes);
    localStorage.setItem("network_sync_status", syncRes);
    return /* () */0;
  } else {
    console.log("sync config not missing");
    return /* () */0;
  }
}

function setEntryFresh(entry) {
  var res = pullSyncConfig(/* () */0);
  console.log("setEntryFresh");
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 0, "fresh");
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 1, Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), Date.now()));
  var syncRes = Json.stringify(res);
  localStorage.setItem("network_sync_status", syncRes);
  return /* () */0;
}

function setEntrySynced(entry, stamp) {
  var res = pullSyncConfig(/* () */0);
  console.log("set entry synced: ", entry);
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 0, "synced");
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 1, Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), stamp));
  var syncRes = Json.stringify(res);
  localStorage.setItem("network_sync_status", syncRes);
  return /* () */0;
}

function setEntrySyncedString(entry, stamp) {
  var res = pullSyncConfig(/* () */0);
  console.log("set entry synced string: ", entry);
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 0, "synced");
  Caml_array.caml_array_set(Caml_array.caml_array_get(res, entry), 1, stamp);
  var syncRes = Json.stringify(res);
  console.log("set entry synced string syncRes: ", syncRes);
  localStorage.setItem("network_sync_status", syncRes);
  return /* () */0;
}

function getUrlParamCode(reqType) {
  var url = ReasonReact.Router[/* dangerouslyGetInitialUrl */3](/* () */0);
  var search = url[/* search */2];
  var codeFromUrl = function (myString) {
    var param = new RegExp("token=(\\w+)").exec(myString);
    if (param !== null) {
      return Js_primitive.null_undefined_to_opt(Caml_array.caml_array_get(param, 1));
    } else {
      return /* None */0;
    }
  };
  var cleanCode = function () {
    var match = codeFromUrl(search);
    if (match) {
      return match[0];
    } else {
      return "";
    }
  };
  var cleanCodeString = cleanCode(/* () */0);
  var emailFromUrl = function (myString) {
    var param = new RegExp("email=(.+)").exec(myString);
    if (param !== null) {
      return Js_primitive.null_undefined_to_opt(Caml_array.caml_array_get(param, 1));
    } else {
      return /* None */0;
    }
  };
  var emailRes = function () {
    var match = emailFromUrl(search);
    if (match) {
      return match[0];
    } else {
      return "";
    }
  };
  var emailAdr = emailRes(/* () */0);
  var cleanR = (
      function(a) {
        return decodeURIComponent(a);
        }
      );
  var cleanEmail = Curry._1(cleanR, emailAdr);
  if (reqType !== 0) {
    return cleanEmail;
  } else {
    return cleanCodeString;
  }
}

function decodePayload(json) {
  return Json_decode.field("payload", Json_decode.string, json);
}

function decodeEmail(json) {
  return Json_decode.field("email", Json_decode.string, json);
}

function storeEmail(email) {
  console.log("email: ", email);
  var emailRes = Json.stringify(email);
  localStorage.setItem("email", emailRes);
  return /* () */0;
}

function checkEmail(jsonVal) {
  var exit = 0;
  var returnString;
  try {
    returnString = Json_decode.string(jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("email parsing failure: ", x[1]);
      return /* None */0;
    } else {
      console.log("email parsing issue: ", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnString];
  }
  
}

function readEmailFromLs() {
  var match = localStorage.getItem("email");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("email checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkEmail(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullEmail() {
  var match = readEmailFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return "";
  }
}

function jsonParse$1(vals) {
  try {
    return JSON.parse(vals);
  }
  catch (exn){
    return Pervasives.failwith("Error parsing JSON string");
  }
}

function successFuncPush(data) {
  return Promise.resolve(data).then((function (prim) {
                    return prim.json();
                  })).then((function (json) {
                  Json_decode.field("payload", Json_decode.string, json);
                  return Promise.resolve((console.log("data push real success"), /* () */0));
                })).catch((function (err) {
                return Promise.resolve((console.log("network call response parse error", err), /* () */0));
              }));
}

function issueFunc(data) {
  return Promise.resolve(data).then((function () {
                  console.log("Call error!", data);
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("Login error exception", err), /* () */0));
              }));
}

function issueFunc2(data) {
  return Promise.resolve(data).then((function () {
                  console.log("Other error!");
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                return Promise.resolve((console.log("Other http error exception", err), /* () */0));
              }));
}

function pushData(dataType, payload, arrNumber) {
  console.log("initiating data push of: ", dataType);
  var stamp = Date.now();
  var requestPayload = Json_encode.object_(/* :: */[
        /* tuple */[
          dataType,
          payload
        ],
        /* :: */[
          /* tuple */[
            "update_" + dataType,
            Curry._1(Printf.sprintf(/* Format */[
                      /* Float */Block.__(8, [
                          /* Float_f */0,
                          /* No_padding */0,
                          /* Lit_precision */[1],
                          /* End_of_format */0
                        ]),
                      "%.1f"
                    ]), stamp)
          ],
          /* [] */0
        ]
      ]);
  var requestPayloadContainer = Json_encode.object_(/* :: */[
        /* tuple */[
          "payload",
          JSON.stringify(requestPayload)
        ],
        /* [] */0
      ]);
  fetch(dataUrl, Fetch.RequestInit[/* make */0](/* Some */[/* Put */3], /* Some */[{
                    "Content-Type": "application/json",
                    Accept: "application.json",
                    Authorization: "Bearer " + getBearer(/* () */0)
                  }], /* Some */[JSON.stringify(requestPayloadContainer)], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
            var statusCode = data.status;
            console.log("https status: ", statusCode);
            var switcher = statusCode - 400 | 0;
            if (switcher === 0 || switcher === 1) {
              if (switcher !== 0) {
                console.log("issue 401: ", data);
                return issueFunc(data);
              } else {
                console.log("issue 400: ", data);
                return issueFunc(data);
              }
            } else if (switcher !== -200) {
              console.log("network isse: ", data);
              return issueFunc2(data);
            } else {
              setEntrySynced(arrNumber, stamp);
              return successFuncPush(data);
            }
          })).catch((function (err) {
          return Promise.resolve((console.log("api error push: ", err), /* () */0));
        }));
  return /* () */0;
}

function decodePayloadKeyStart(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, Json_decode.string, json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message start fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message start exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyWizard(theKey, json) {
  var res = function (json) {
    return /* record */[
            /* weight */Json_decode.field("weight", Json_decode.$$int, json),
            /* cals */Json_decode.field("cals", Json_decode.$$int, json),
            /* duration */Json_decode.field("duration", Json_decode.$$int, json)
          ];
  };
  var value;
  var exit = 0;
  var myObj;
  try {
    myObj = Json_decode.field(theKey, res, json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message wizard exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myObj];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr;
  try {
    myArr = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyLevels(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array(Json_decode.$$int, param);
                        }), param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message levels fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message levels exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message levels date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message levels date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyReps(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array((function (param) {
                                        return Json_decode.array(Json_decode.$$int, param);
                                      }), param);
                        }), param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message reps fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message reps exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message reps date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message reps date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyPoints(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array((function (param) {
                                        return Json_decode.array(Json_decode.$$int, param);
                                      }), param);
                        }), param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message points fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message points exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message points date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message points date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyCompleted(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array(Json_decode.bool, param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message completed fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message completed exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message completed date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message completed date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyFood(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array((function (param) {
                                        return Json_decode.array(Json_decode.string, param);
                                      }), param);
                        }), param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message food fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message food exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message date food exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyBonus(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array(Json_decode.bool, param);
                        }), param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message bonus exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function decodePayloadKeyKnowledge(theKey, json) {
  var value;
  var exit = 0;
  var myArr;
  try {
    myArr = Json_decode.field(theKey, (function (param) {
            return Json_decode.array(Json_decode.bool, param);
          }), json);
    exit = 1;
  }
  catch (raw_message){
    var message = Js_exn.internalToOCamlException(raw_message);
    if (message[0] === Caml_builtin_exceptions.failure) {
      console.log("message read fail: ", message[1]);
      value = /* None */0;
    } else {
      console.log("message read exception: ", message);
      value = /* None */0;
    }
  }
  if (exit === 1) {
    value = /* Some */[myArr];
  }
  var syncDate;
  var exit$1 = 0;
  var myArr$1;
  try {
    myArr$1 = Json_decode.field("update_" + theKey, Json_decode.string, json);
    exit$1 = 1;
  }
  catch (raw_message$1){
    var message$1 = Js_exn.internalToOCamlException(raw_message$1);
    if (message$1[0] === Caml_builtin_exceptions.failure) {
      console.log("message read date fail: ", message$1[1]);
      syncDate = /* None */0;
    } else {
      console.log("message read date exception: ", message$1);
      syncDate = /* None */0;
    }
  }
  if (exit$1 === 1) {
    syncDate = /* Some */[myArr$1];
  }
  return /* record */[
          /* value */value,
          /* syncDate */syncDate
        ];
}

function readWizardResultFromLs(rawJson) {
  try {
    var json = rawJson;
    return /* record */[
            /* weight */Json_decode.field("weight", Json_decode.$$int, json),
            /* cals */Json_decode.field("cals", Json_decode.$$int, json),
            /* duration */Json_decode.field("duration", Json_decode.$$int, json)
          ];
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("exception in unpack", x);
    ReasonReact.Router[/* push */0]("/wizard/1");
    return /* record */[
            /* weight */0,
            /* cals */0,
            /* duration */0
          ];
  }
}

function readWizardResultFromLsOption(rawJson) {
  var res = function (json) {
    return /* record */[
            /* weight */Json_decode.field("weight", Json_decode.$$int, json),
            /* cals */Json_decode.field("cals", Json_decode.$$int, json),
            /* duration */Json_decode.field("duration", Json_decode.$$int, json)
          ];
  };
  var exit = 0;
  var result;
  try {
    result = res(rawJson);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("exception in unpack", x);
    return /* None */0;
  }
  if (exit === 1) {
    var match = +(result[/* weight */0] === 0);
    if (match !== 0) {
      return /* None */0;
    } else {
      return /* Some */[result];
    }
  }
  
}

function getWeight() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getWeight exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        return readWizardResultFromLs(x[0])[/* weight */0];
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function getDuration() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getDuration exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        return readWizardResultFromLs(x[0])[/* duration */2];
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function getCals() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getDuration exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        var match$1 = readWizardResultFromLs(x[0])[/* cals */1];
        if (match$1 !== 1100) {
          if (match$1 !== 1300) {
            if (match$1 !== 1500) {
              return 0;
            } else {
              return 1500;
            }
          } else {
            return 1300;
          }
        } else {
          return 1100;
        }
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function pullWizardConfig() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("exception in unpack", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        return readWizardResultFromLsOption(x[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function wizardEncoder(weight, cals, duration) {
  return Json_encode.object_(/* :: */[
              /* tuple */[
                "weight",
                weight
              ],
              /* :: */[
                /* tuple */[
                  "cals",
                  cals
                ],
                /* :: */[
                  /* tuple */[
                    "duration",
                    duration
                  ],
                  /* [] */0
                ]
              ]
            ]);
}

function pushWizard(w, c, d) {
  pushData("wizard_result", wizardEncoder(w, c, d), 1);
  console.log("wizard data maybe pushed to server");
  return /* () */0;
}

function setLocalWizard(w, c, d) {
  var wizardRes = JSON.stringify(wizardEncoder(w, c, d));
  localStorage.setItem("wizard_result", wizardRes);
  setEntryFresh(1);
  console.log("wizard data set fresh");
  return /* () */0;
}

function safeWizardResultToLs(param) {
  var d = param[2];
  var c = param[1];
  var w = param[0];
  setLocalWizard(w, c, d);
  return pushWizard(w, c, d);
}

function updateWizardResultToLS(d) {
  var w = getWeight(/* () */0);
  var c = getCals(/* () */0);
  setLocalWizard(w, c, d);
  return pushWizard(w, c, d);
}

function updateWizardCalsResultToLS(c) {
  var w = getWeight(/* () */0);
  var d = getDuration(/* () */0);
  setLocalWizard(w, c, d);
  return pushWizard(w, c, d);
}

function pushStart(start) {
  pushData("start_date_timestamp", Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), start), 0);
  console.log("start date pushed to server");
  return /* () */0;
}

function setLocalStart(start) {
  localStorage.setItem("start_date_timestamp", Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), start));
  return setEntryFresh(0);
}

function setLocalStartString(start) {
  localStorage.setItem("start_date_timestamp", start);
  return setEntryFresh(0);
}

function saveFirstWorkoutDate() {
  var now = Date.now();
  setLocalStart(now);
  return pushStart(now);
}

function resetStartDate() {
  setLocalStart(0.0);
  return pushStart(0.0);
}

function pullStart() {
  var match = localStorage.getItem("start_date_timestamp");
  if (match !== null) {
    try {
      return Caml_format.caml_float_of_string(match);
    }
    catch (exn){
      console.log("issue with startDate conversion to float");
      return 1.0;
    }
  } else {
    return 0.0;
  }
}

function checkLevels(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array(Json_decode.$$int, param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("expiry parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("expiry parsing issue!", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readLevelSettingsFromLs() {
  var match = localStorage.getItem("levels");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("levels in checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkLevels(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullLevelConfig() {
  var match = readLevelSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.workoutLevels;
  }
}

function pushLevels(levels) {
  pushData("levels", levels, 2);
  console.log("levels data pushed to server");
  return /* () */0;
}

function setLocalLevels(allLev) {
  var levelRes = Json.stringify(allLev);
  localStorage.setItem("levels", levelRes);
  return setEntryFresh(2);
}

function safeLevelSettingsToLs(lev, allLev, ind) {
  var newLevels = $$Array.copy(allLev);
  Caml_array.caml_array_set(newLevels, ind, lev);
  setLocalLevels(newLevels);
  return pushLevels(newLevels);
}

function resetLevels() {
  setLocalLevels(Seed.workoutLevels);
  return pushLevels(Seed.workoutLevels);
}

function checkReps(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array(Json_decode.$$int, param);
                        }), param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("expiry parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("expiry parsing issue!", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readRepsSettingsFromLs() {
  var match = localStorage.getItem("reps");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("reps checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkReps(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullRepsConfig() {
  var match = readRepsSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.workoutReps;
  }
}

function checkPoints(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array(Json_decode.$$int, param);
                        }), param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("expiry parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("expiry parsing issue!", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readPointsSettingsFromLs() {
  var match = localStorage.getItem("points");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("Points checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkPoints(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullPointsConfig() {
  var match = readPointsSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.workoutReps;
  }
}

function calcPointsOverall(points) {
  var res1 = function (arr) {
    return $$Array.fold_left((function (x, y) {
                  return x + y | 0;
                }), 0, arr);
  };
  var res2 = function (arr) {
    return $$Array.fold_left((function (x, y) {
                  return x + res1(y) | 0;
                }), 0, arr);
  };
  var arr = points;
  return $$Array.fold_left((function (x, y) {
                return x + res2(y) | 0;
              }), 0, arr);
}

function calcPointsWeek(week) {
  var start = Caml_int32.imul(6, week) - 6 | 0;
  return calcPointsOverall($$Array.sub(pullPointsConfig(/* () */0), start, 6));
}

function pushReps(reps) {
  return pushData("reps", reps, 3);
}

function setLocalReps(reps) {
  var repsRes = Json.stringify(reps);
  localStorage.setItem("reps", repsRes);
  return setEntryFresh(3);
}

function pushPoints(points) {
  return pushData("points", points, 4);
}

function setLocalPoints(points) {
  var repsResPoints = Json.stringify(points);
  localStorage.setItem("points", repsResPoints);
  return setEntryFresh(4);
}

function storePoints(workoutIndex, round, pair, exCur1, exCur2, levels) {
  var newArrPoints = pullPointsConfig(/* () */0);
  Caml_array.caml_array_set(Caml_array.caml_array_get(Caml_array.caml_array_get(newArrPoints, workoutIndex), round - 1 | 0), (pair << 1) - 2 | 0, Caml_int32.imul(exCur1, Caml_array.caml_array_get(levels, (pair << 1) - 2 | 0)));
  Caml_array.caml_array_set(Caml_array.caml_array_get(Caml_array.caml_array_get(newArrPoints, workoutIndex), round - 1 | 0), (pair << 1) - 1 | 0, Caml_int32.imul(exCur2, Caml_array.caml_array_get(levels, (pair << 1) - 1 | 0)));
  setLocalPoints(newArrPoints);
  return pushPoints(newArrPoints);
}

function resetSinglePoints(workoutIndex) {
  var newArrPoints = pullPointsConfig(/* () */0);
  Caml_array.caml_array_set(newArrPoints, workoutIndex, Caml_array.caml_array_get(Seed.workoutReps, workoutIndex));
  setLocalPoints(newArrPoints);
  return pushPoints(newArrPoints);
}

function storeReps(workoutIndex, round, pair, exCur1, exCur2, _) {
  var newArr = pullRepsConfig(/* () */0);
  Caml_array.caml_array_set(Caml_array.caml_array_get(Caml_array.caml_array_get(newArr, workoutIndex), round - 1 | 0), (pair << 1) - 2 | 0, exCur1);
  Caml_array.caml_array_set(Caml_array.caml_array_get(Caml_array.caml_array_get(newArr, workoutIndex), round - 1 | 0), (pair << 1) - 1 | 0, exCur2);
  setLocalReps(newArr);
  return pushReps(newArr);
}

function resetSingleReps(workoutIndex) {
  var newArr = pullRepsConfig(/* () */0);
  Caml_array.caml_array_set(newArr, workoutIndex, Caml_array.caml_array_get(Seed.workoutReps, workoutIndex));
  setLocalReps(newArr);
  return pushReps(newArr);
}

function storePointsAndReps(workoutIndex, round, pair, exCur1, exCur2, levels) {
  storePoints(workoutIndex, round, pair, exCur1, exCur2, levels);
  return storeReps(workoutIndex, round, pair, exCur1, exCur2, levels);
}

function resetPointsAndReps() {
  setLocalReps(Seed.workoutReps);
  pushReps(Seed.workoutReps);
  setLocalPoints(Seed.workoutReps);
  return pushPoints(Seed.workoutReps);
}

function checkCompleted(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array(Json_decode.bool, jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("completion parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("completion parsing issue!", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readCompletedSettingsFromLs() {
  var match = localStorage.getItem("completed");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("Completion checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkCompleted(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullCompletedConfig() {
  var match = readCompletedSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.completedArray;
  }
}

function pushCompleted(completed) {
  var compRes = completed.map(Json_encode.bool);
  return pushData("completed", compRes, 5);
}

function setLocalCompleted(completed) {
  var compRes = Json.stringify(completed.map(Json_encode.bool));
  localStorage.setItem("completed", compRes);
  return setEntryFresh(5);
}

function storeCompletedWorkout(workoutIndex) {
  var completedArray = pullCompletedConfig(/* () */0);
  Caml_array.caml_array_set(completedArray, workoutIndex, /* true */1);
  setLocalCompleted(completedArray);
  return pushCompleted(completedArray);
}

function resetSingleCompletedWorkout(workoutIndex) {
  var completedArray = pullCompletedConfig(/* () */0);
  Caml_array.caml_array_set(completedArray, workoutIndex, /* false */0);
  setLocalCompleted(completedArray);
  return pushCompleted(completedArray);
}

function resetCompleted() {
  setLocalCompleted(Seed.completedArray);
  return pushCompleted(Seed.completedArray);
}

function check16Completed() {
  var data = pullCompletedConfig(/* () */0);
  var sumOfDone = $$Array.fold_left((function (summer, el) {
          var match = +(el === /* true */1);
          var elInt = match !== 0 ? 1 : 0;
          return summer + elInt | 0;
        }), 0, data);
  var match = +(sumOfDone === 16);
  if (match !== 0) {
    return /* true */1;
  } else {
    return /* false */0;
  }
}

function checkKnowledge(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array(Json_decode.bool, jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("read parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("read parsing issue!", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readKnowledgeSettingsFromLs() {
  var match = localStorage.getItem("knowledge_read");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("read checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkKnowledge(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullKnowledgeConfig() {
  var match = readKnowledgeSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.knowledgeRead;
  }
}

function pushKnowledge(read) {
  var readRes = read.map(Json_encode.bool);
  return pushData("knowledge_read", readRes, 8);
}

function setLocalKnowledge(read) {
  var readRes = Json.stringify(read.map(Json_encode.bool));
  localStorage.setItem("knowledge_read", readRes);
  return setEntryFresh(8);
}

function storeKnowledgeRead(index) {
  var knowledgeArray = pullKnowledgeConfig(/* () */0);
  Caml_array.caml_array_set(knowledgeArray, index, /* true */1);
  setLocalKnowledge(knowledgeArray);
  return pushKnowledge(knowledgeArray);
}

function resetKnowledge() {
  setLocalKnowledge(Seed.knowledgeRead);
  return pushKnowledge(Seed.knowledgeRead);
}

function checkFood(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array((function (param) {
                          return Json_decode.array(Json_decode.string, param);
                        }), param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("food parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("food parsing issue", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readFoodSettingsFromLs() {
  var match = localStorage.getItem("food_plan");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("food checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkFood(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullFoodConfig() {
  var match = readFoodSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return FoodSeed.foodPlanSeed;
  }
}

function getStageNumber(stage) {
  switch (stage) {
    case "breakfast" : 
        return 0;
    case "dinner" : 
        return 3;
    case "lunch" : 
        return 2;
    case "snack" : 
        return 1;
    default:
      return 0;
  }
}

function pushFood(food) {
  var foodRes = Json.stringify(food);
  pushData("food_plan", jsonParse$1(foodRes), 6);
  console.log("bonus data pushed to server maybe");
  return /* () */0;
}

function setLocalFood(food) {
  var foodRes = Json.stringify(food);
  localStorage.setItem("food_plan", foodRes);
  return setEntryFresh(6);
}

function writeFoodToLs(day, stage, foodType, payload) {
  var stageNum = getStageNumber(stage);
  var food = pullFoodConfig(/* () */0);
  Caml_array.caml_array_set(Caml_array.caml_array_get(Caml_array.caml_array_get(food, day - 1 | 0), stageNum), foodType - 1 | 0, payload);
  setLocalFood(food);
  return pushFood(food);
}

function resetFood() {
  setLocalFood(FoodSeed.foodPlanSeed);
  return pushFood(FoodSeed.foodPlanSeed);
}

function getStageFood(day, stage) {
  var food = pullFoodConfig(/* () */0);
  var stageNum = getStageNumber(stage);
  return Caml_array.caml_array_get(Caml_array.caml_array_get(food, day - 1 | 0), stageNum);
}

function checkBonus(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array((function (param) {
            return Json_decode.array(Json_decode.bool, param);
          }), jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("bonus parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("bonus parsing issue", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readBonusSettingsFromLs() {
  var match = localStorage.getItem("bonus_done");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse$1(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("bonus checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkBonus(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

function pullBonusConfig() {
  var match = readBonusSettingsFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return Seed.bonusDone;
  }
}

function pushBonus(bonus) {
  var bonusRes = bonus.map((function (x) {
          return x.map(Json_encode.bool);
        }));
  pushData("bonus_done", bonusRes, 7);
  console.log("bonus data pushed to server");
  return /* () */0;
}

function setLocalBonus(networkPayload) {
  var bonusRes = Json.stringify(networkPayload.map((function (x) {
              return x.map(Json_encode.bool);
            })));
  localStorage.setItem("bonus_done", bonusRes);
  return setEntryFresh(7);
}

function writeBonusToLs(week, payload) {
  var bonus = pullBonusConfig(/* () */0);
  Caml_array.caml_array_set(bonus, Caml_format.caml_int_of_string(week) - 1 | 0, payload);
  setLocalBonus(bonus);
  return pushBonus(bonus);
}

function resetBonus() {
  setLocalBonus(Seed.bonusDone);
  return pushBonus(Seed.bonusDone);
}

function syncStart(networkPayload) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 0), 1);
  var serverDate = networkPayload[/* syncDate */1];
  var start = pullStart(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("serverdate: ", sDate);
      console.log("pushing start data up");
      pushStart(start);
    }
    if (localDate < sDate) {
      console.log("pulling start data down");
      var match = networkPayload[/* value */0];
      if (match) {
        setLocalStartString(match[0]);
        console.log("set start entry synced");
        setEntrySyncedString(0, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushStart(start);
    }
    
  }
  return /* () */0;
}

function pushWizardMaybe(wizard) {
  if (wizard) {
    var res = wizard[0];
    return pushWizard(res[/* weight */0], res[/* cals */1], res[/* duration */2]);
  } else {
    return ReasonReact.Router[/* push */0]("/wizard/1");
  }
}

function syncWizard(networkPayload) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 1), 1);
  var serverDate = networkPayload[/* syncDate */1];
  var wizard = pullWizardConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing wizard * data up");
      pushWizardMaybe(wizard);
    }
    if (localDate < sDate) {
      console.log("pulling wizard * data down");
      var match = networkPayload[/* value */0];
      if (match) {
        var res = match[0];
        setLocalWizard(res[/* weight */0], res[/* cals */1], res[/* duration */2]);
        console.log("server data for wizard synced to local");
        setEntrySyncedString(1, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushWizardMaybe(wizard);
    } else {
      ReasonReact.Router[/* push */0]("/wizard/1");
    }
  }
  return /* () */0;
}

function syncLevels(networkPayload) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 2), 1);
  var serverDate = networkPayload[/* syncDate */1];
  var levels = pullLevelConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing level data up");
      pushLevels(levels);
    }
    if (localDate < sDate) {
      console.log("pulling level data down");
      var match = networkPayload[/* value */0];
      if (match) {
        setLocalLevels(match[0]);
        console.log("pulling levels data down success");
        setEntrySyncedString(2, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushLevels(levels);
    }
    
  }
  return /* () */0;
}

function syncPoints(networkPayload2) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 4), 1);
  var serverDate = networkPayload2[/* syncDate */1];
  var points = pullPointsConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    console.log("serverdate: ", sDate);
    console.log("localdate: ", localDate);
    if (localDate > sDate) {
      console.log("pushing points data up");
      console.log("serverdate: ", sDate);
      console.log("localdate: ", localDate);
      pushPoints(points);
    }
    if (localDate < sDate) {
      console.log("pulling points data down");
      var match = networkPayload2[/* value */0];
      if (match) {
        setLocalPoints(match[0]);
        console.log("pulling points data down success");
        setEntrySyncedString(4, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushPoints(points);
    }
    
  }
  return /* () */0;
}

function syncReps(networkPayload2) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 3), 1);
  var serverDate = networkPayload2[/* syncDate */1];
  var reps = pullRepsConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing reps data up");
      pushReps(reps);
    }
    if (localDate < sDate) {
      console.log("pulling reps data down");
      var match = networkPayload2[/* value */0];
      if (match) {
        setLocalReps(match[0]);
        setEntrySyncedString(3, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushReps(reps);
    }
    
  }
  return /* () */0;
}

function syncCompleted(networkPayload2) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 5), 1);
  var serverDate = networkPayload2[/* syncDate */1];
  var completed = pullCompletedConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing completed data up");
      pushCompleted(completed);
    }
    if (localDate < sDate) {
      console.log("pulling completed data down");
      var match = networkPayload2[/* value */0];
      if (match) {
        setLocalCompleted(match[0]);
        console.log("pulling completed data down success");
        setEntrySyncedString(5, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushCompleted(completed);
    }
    
  }
  return /* () */0;
}

function syncFood(networkPayload2) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 6), 1);
  var serverDate = networkPayload2[/* syncDate */1];
  var food = pullFoodConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing data up");
      pushFood(food);
    }
    if (localDate < sDate) {
      console.log("pulling food data down");
      var match = networkPayload2[/* value */0];
      if (match) {
        setLocalFood(match[0]);
        console.log("pulling food data down success");
        setEntrySyncedString(6, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushFood(food);
    }
    
  }
  return /* () */0;
}

function syncBonus(networkPayload) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 7), 1);
  var serverDate = networkPayload[/* syncDate */1];
  var bonus = pullBonusConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing data up");
      pushBonus(bonus);
    }
    if (localDate < sDate) {
      console.log("pulling bonus data down");
      var match = networkPayload[/* value */0];
      if (match) {
        setLocalBonus(match[0]);
        console.log("pulling bonus data down success");
        setEntrySyncedString(7, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushBonus(bonus);
    }
    
  }
  return /* () */0;
}

function syncKnowledge(networkPayload2) {
  var localDate = Caml_array.caml_array_get(Caml_array.caml_array_get(pullSyncConfig(/* () */0), 8), 1);
  var serverDate = networkPayload2[/* syncDate */1];
  var read = pullKnowledgeConfig(/* () */0);
  if (serverDate) {
    var sDate = serverDate[0];
    if (localDate > sDate) {
      console.log("pushing read data up");
      pushKnowledge(read);
    }
    if (localDate < sDate) {
      console.log("pulling read data down");
      var match = networkPayload2[/* value */0];
      if (match) {
        setLocalKnowledge(match[0]);
        console.log("pulling read data down success");
        setEntrySyncedString(8, sDate);
      }
      
    }
    
  } else {
    var match$1 = +(localDate > "0.0");
    if (match$1 !== 0) {
      pushKnowledge(read);
    }
    
  }
  return /* () */0;
}

function syncStartWrapper(data) {
  return syncStart(decodePayloadKeyStart("start_date_timestamp", data));
}

function syncWizardWrapper(data) {
  return syncWizard(decodePayloadKeyWizard("wizard_result", data));
}

function syncLevelsWrapper(data) {
  return syncLevels(decodePayloadKeyLevels("levels", data));
}

function syncRepsAndPointsWrapper(data) {
  syncReps(decodePayloadKeyReps("reps", data));
  return syncPoints(decodePayloadKeyPoints("points", data));
}

function syncCompletedWrapper(data) {
  return syncCompleted(decodePayloadKeyCompleted("completed", data));
}

function syncFoodWrapper(data) {
  return syncFood(decodePayloadKeyFood("food_plan", data));
}

function syncBonusWrapper(data) {
  return syncBonus(decodePayloadKeyBonus("bonus_done", data));
}

function syncKnowledgeWrapper(data) {
  return syncKnowledge(decodePayloadKeyKnowledge("knowledge_read", data));
}

function successSyncAllRunner(data, cb) {
  return Promise.resolve(data).then((function (prim) {
                    return prim.json();
                  })).then((function (json) {
                  var email = Json_decode.field("email", Json_decode.string, json);
                  storeEmail(email);
                  console.log("get Email from LS: ", pullEmail(/* () */0));
                  var parsed = jsonParse$1(Json_decode.field("payload", Json_decode.string, json));
                  syncStart(decodePayloadKeyStart("start_date_timestamp", parsed));
                  syncWizard(decodePayloadKeyWizard("wizard_result", parsed));
                  syncLevels(decodePayloadKeyLevels("levels", parsed));
                  syncRepsAndPointsWrapper(parsed);
                  syncCompleted(decodePayloadKeyCompleted("completed", parsed));
                  syncFood(decodePayloadKeyFood("food_plan", parsed));
                  syncBonus(decodePayloadKeyBonus("bonus_done", parsed));
                  syncKnowledge(decodePayloadKeyKnowledge("knowledge_read", parsed));
                  console.log("all synced");
                  Curry._1(cb, /* () */0);
                  return Promise.resolve(/* () */0);
                })).catch((function (err) {
                console.log("network call response parse error", err);
                Curry._1(cb, /* () */0);
                return Promise.resolve(/* () */0);
              }));
}

function redirectToDash() {
  console.log("+++ Redirecting to dash +++");
  return ReasonReact.Router[/* push */0]("/dashboard");
}

function successSyncAll(data) {
  return successSyncAllRunner(data, redirectToDash);
}

var successSyncAllNoRedirect = successSyncAllRunner;

function resetAll() {
  console.log("resetting");
  resetStartDate(/* () */0);
  safeWizardResultToLs(/* tuple */[
        0,
        0,
        0
      ]);
  setLocalLevels(Seed.workoutLevels);
  pushLevels(Seed.workoutLevels);
  resetPointsAndReps(/* () */0);
  setLocalCompleted(Seed.completedArray);
  pushCompleted(Seed.completedArray);
  setLocalFood(FoodSeed.foodPlanSeed);
  pushFood(FoodSeed.foodPlanSeed);
  setLocalBonus(Seed.bonusDone);
  pushBonus(Seed.bonusDone);
  setLocalKnowledge(Seed.knowledgeRead);
  return pushKnowledge(Seed.knowledgeRead);
}

function pullData(dataType, cb) {
  console.log("initiating data pull of all or: ", dataType);
  var match = +(dataType === "");
  var urlParams = match !== 0 ? "" : "&payload=" + (dataType + (",update_" + dataType));
  var url = dataUrl + urlParams;
  fetch(url, Fetch.RequestInit[/* make */0](/* Some */[/* Get */0], /* Some */[{
                    Accept: "application.json",
                    Authorization: "Bearer " + getBearer(/* () */0)
                  }], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0)(/* () */0)).then((function (data) {
            var statusCode = data.status;
            console.log("https status in pull: ", statusCode);
            var switcher = statusCode - 400 | 0;
            if (switcher === 0 || switcher === 1) {
              if (switcher !== 0) {
                console.log("issue 401: ", data);
                return issueFunc(data);
              } else {
                console.log("issue 400: ", data);
                return issueFunc(data);
              }
            } else if (switcher !== -200) {
              console.log("network isse: ", data);
              return issueFunc2(data);
            } else {
              console.log("success pulling data", data);
              return Curry._1(cb, data);
            }
          })).catch((function (err) {
          return Promise.resolve((console.log("api error pull: ", err), /* () */0));
        }));
  return /* () */0;
}

var clientId = "1";

var clientSecret = "pie8Eu2JmeanoJe6ab2eiCaekeiGooD6";

var mBBClientId = "2";

var mBBClientSecret = "64fe59360a1142f5ac43c585c35c43c6";

var grantType = "password";

var loginUrl = "https://shopify.ilpt.de/api/access_token?shop=ilptbook.myshopify.com";

var registerUrl = "https://shopify.ilpt.de/api/apps/?shop=ilptbook.myshopify.com";

var resetUrl = "https://shopify.ilpt.de/api/apps/password-reset?shop=ilptbook.myshopify.com&product=mbb-ebook";

var resetExecUrl = "https://shopify.ilpt.de/api/apps/password-reset?shop=ilptbook.myshopify.com";

exports.clientId = clientId;
exports.clientSecret = clientSecret;
exports.mBBClientId = mBBClientId;
exports.mBBClientSecret = mBBClientSecret;
exports.grantType = grantType;
exports.loginUrl = loginUrl;
exports.registerUrl = registerUrl;
exports.resetUrl = resetUrl;
exports.resetExecUrl = resetExecUrl;
exports.dataUrl = dataUrl;
exports.getBearer = getBearer;
exports.networkSyncStatusSeed = networkSyncStatusSeed;
exports.checkSync = checkSync;
exports.readSyncSettingsFromLs = readSyncSettingsFromLs;
exports.pullSyncConfig = pullSyncConfig;
exports.checkSyncConfigMissing = checkSyncConfigMissing;
exports.writeSyncStatusToLs = writeSyncStatusToLs;
exports.initializeSyncStatus2 = initializeSyncStatus2;
exports.setEntryFresh = setEntryFresh;
exports.setEntrySynced = setEntrySynced;
exports.setEntrySyncedString = setEntrySyncedString;
exports.getUrlParamCode = getUrlParamCode;
exports.decodePayload = decodePayload;
exports.decodeEmail = decodeEmail;
exports.storeEmail = storeEmail;
exports.checkEmail = checkEmail;
exports.readEmailFromLs = readEmailFromLs;
exports.pullEmail = pullEmail;
exports.jsonParse = jsonParse$1;
exports.successFuncPush = successFuncPush;
exports.issueFunc = issueFunc;
exports.issueFunc2 = issueFunc2;
exports.pushData = pushData;
exports.decodePayloadKeyStart = decodePayloadKeyStart;
exports.decodePayloadKeyWizard = decodePayloadKeyWizard;
exports.decodePayloadKeyLevels = decodePayloadKeyLevels;
exports.decodePayloadKeyReps = decodePayloadKeyReps;
exports.decodePayloadKeyPoints = decodePayloadKeyPoints;
exports.decodePayloadKeyCompleted = decodePayloadKeyCompleted;
exports.decodePayloadKeyFood = decodePayloadKeyFood;
exports.decodePayloadKeyBonus = decodePayloadKeyBonus;
exports.decodePayloadKeyKnowledge = decodePayloadKeyKnowledge;
exports.readWizardResultFromLs = readWizardResultFromLs;
exports.readWizardResultFromLsOption = readWizardResultFromLsOption;
exports.getWeight = getWeight;
exports.getDuration = getDuration;
exports.getCals = getCals;
exports.pullWizardConfig = pullWizardConfig;
exports.wizardEncoder = wizardEncoder;
exports.pushWizard = pushWizard;
exports.setLocalWizard = setLocalWizard;
exports.safeWizardResultToLs = safeWizardResultToLs;
exports.updateWizardResultToLS = updateWizardResultToLS;
exports.updateWizardCalsResultToLS = updateWizardCalsResultToLS;
exports.pushStart = pushStart;
exports.setLocalStart = setLocalStart;
exports.setLocalStartString = setLocalStartString;
exports.saveFirstWorkoutDate = saveFirstWorkoutDate;
exports.resetStartDate = resetStartDate;
exports.pullStart = pullStart;
exports.checkLevels = checkLevels;
exports.readLevelSettingsFromLs = readLevelSettingsFromLs;
exports.pullLevelConfig = pullLevelConfig;
exports.pushLevels = pushLevels;
exports.setLocalLevels = setLocalLevels;
exports.safeLevelSettingsToLs = safeLevelSettingsToLs;
exports.resetLevels = resetLevels;
exports.checkReps = checkReps;
exports.readRepsSettingsFromLs = readRepsSettingsFromLs;
exports.pullRepsConfig = pullRepsConfig;
exports.checkPoints = checkPoints;
exports.readPointsSettingsFromLs = readPointsSettingsFromLs;
exports.pullPointsConfig = pullPointsConfig;
exports.calcPointsOverall = calcPointsOverall;
exports.calcPointsWeek = calcPointsWeek;
exports.pushReps = pushReps;
exports.setLocalReps = setLocalReps;
exports.pushPoints = pushPoints;
exports.setLocalPoints = setLocalPoints;
exports.storePoints = storePoints;
exports.resetSinglePoints = resetSinglePoints;
exports.storeReps = storeReps;
exports.resetSingleReps = resetSingleReps;
exports.storePointsAndReps = storePointsAndReps;
exports.resetPointsAndReps = resetPointsAndReps;
exports.checkCompleted = checkCompleted;
exports.readCompletedSettingsFromLs = readCompletedSettingsFromLs;
exports.pullCompletedConfig = pullCompletedConfig;
exports.pushCompleted = pushCompleted;
exports.setLocalCompleted = setLocalCompleted;
exports.storeCompletedWorkout = storeCompletedWorkout;
exports.resetSingleCompletedWorkout = resetSingleCompletedWorkout;
exports.resetCompleted = resetCompleted;
exports.check16Completed = check16Completed;
exports.checkKnowledge = checkKnowledge;
exports.readKnowledgeSettingsFromLs = readKnowledgeSettingsFromLs;
exports.pullKnowledgeConfig = pullKnowledgeConfig;
exports.pushKnowledge = pushKnowledge;
exports.setLocalKnowledge = setLocalKnowledge;
exports.storeKnowledgeRead = storeKnowledgeRead;
exports.resetKnowledge = resetKnowledge;
exports.checkFood = checkFood;
exports.readFoodSettingsFromLs = readFoodSettingsFromLs;
exports.pullFoodConfig = pullFoodConfig;
exports.getStageNumber = getStageNumber;
exports.pushFood = pushFood;
exports.setLocalFood = setLocalFood;
exports.writeFoodToLs = writeFoodToLs;
exports.resetFood = resetFood;
exports.getStageFood = getStageFood;
exports.checkBonus = checkBonus;
exports.readBonusSettingsFromLs = readBonusSettingsFromLs;
exports.pullBonusConfig = pullBonusConfig;
exports.pushBonus = pushBonus;
exports.setLocalBonus = setLocalBonus;
exports.writeBonusToLs = writeBonusToLs;
exports.resetBonus = resetBonus;
exports.syncStart = syncStart;
exports.pushWizardMaybe = pushWizardMaybe;
exports.syncWizard = syncWizard;
exports.syncLevels = syncLevels;
exports.syncPoints = syncPoints;
exports.syncReps = syncReps;
exports.syncCompleted = syncCompleted;
exports.syncFood = syncFood;
exports.syncBonus = syncBonus;
exports.syncKnowledge = syncKnowledge;
exports.syncStartWrapper = syncStartWrapper;
exports.syncWizardWrapper = syncWizardWrapper;
exports.syncLevelsWrapper = syncLevelsWrapper;
exports.syncRepsAndPointsWrapper = syncRepsAndPointsWrapper;
exports.syncCompletedWrapper = syncCompletedWrapper;
exports.syncFoodWrapper = syncFoodWrapper;
exports.syncBonusWrapper = syncBonusWrapper;
exports.syncKnowledgeWrapper = syncKnowledgeWrapper;
exports.successSyncAllRunner = successSyncAllRunner;
exports.redirectToDash = redirectToDash;
exports.successSyncAll = successSyncAll;
exports.successSyncAllNoRedirect = successSyncAllNoRedirect;
exports.resetAll = resetAll;
exports.pullData = pullData;
/* FoodSeed Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/network.re
// module id = 7
// module chunks = 0